import {API_ADMIN_URL} from "../../../config/constants";
import { postRequest } from '../../API'
/*********************************************************
* Function Name : list
* Description   : Get list of b-points list
* By            : Afsar Ali
* Date          : 16-12-2024 
*********************************************************/
export const list = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}./recharge/points-history`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count: res?.data?.response?.count,};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : addPoints
* Description   : this function is used for add b-points 
* By            : Afsar Ali
* Date          : 16-12-2024 
*********************************************************/
export const addPoints = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}./recharge/add-point`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count: res?.data?.response?.count,};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : reversePoints
* Description   : this function is used for reverse b-points 
* By            : Afsar Ali
* Date          : 17-03-2024 
*********************************************************/
export const reversePoints = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}./recharge/reverse`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count: res?.data?.response?.count,};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function
